<ng-container *transloco="let t">
  <div class="form-container">
    <img src="assets/logo.png" alt="Logo" class="logo" />

    <div class="form-content">
      <h1>{{ t("performLogin") }}</h1>
      <p>
        {{ t("noAccountQuestion") }}
        <a class="highlighted" routerLink="/signup">
          {{ t("goToSignup") }}
        </a>
      </p>

      <form
        class="form"
        #loginForm="ngForm"
        (keydown.enter)="loginForm.valid && login()"
      >
        <p-floatlabel variant="in" class="username-input">
          <input
            pInputText
            [(ngModel)]="authData.username"
            id="username-login"
            autocomplete="off"
            name="username"
            required
          />
          <label for="username-login">{{ t("username") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in" class="password-input">
          <p-password
            [(ngModel)]="authData.password"
            inputId="password-login"
            name="password"
            [appendTo]="'body'"
            [feedback]="false"
            required
            [toggleMask]="true"
          />
          <label for="password-login">{{ t("password") }}</label>
        </p-floatlabel>
      </form>

      <p-button
        [label]="t('login')"
        (click)="login()"
        class="login-button"
        size="large"
        icon="pi pi-arrow-right"
        [disabled]="loginForm.invalid"
      />
    </div>
  </div>

  <div class="illustration-container">
    <img src="assets/login-image.jpeg" alt="Bike sharing" />
  </div>
</ng-container>
